import React from 'react';
import PropTypes from 'prop-types';

const { classNames } = Mobi2Go.helpers;

class AddressFormPredictions extends React.Component {
    static propTypes = {
        highlighted_item: PropTypes.any,
        list: PropTypes.arrayOf(
            PropTypes.shape({
                description: PropTypes.string,
                matched_substrings: PropTypes.array,
                terms: PropTypes.array,
            })
        ),
        onSelect: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        onHighlight: PropTypes.func.isRequired,
        onMouseEnter: PropTypes.func.isRequired,
        onMouseLeave: PropTypes.func.isRequired,
    };

    emphasisMatchedStrings(description, matched_substrings) {
        const sections = [];
        let cursor = 0;
        for (const { offset, length } of matched_substrings) {
            sections.push({
                str: description.substr(cursor, offset - cursor),
            });
            sections.push({
                str: description.substr(offset, length),
                emphasised: true,
            });
            cursor = offset + length;
        }
        if (cursor !== description.length) {
            sections.push({ str: description.substr(cursor) });
        }

        return (
            <span>
                {sections.map(({ str, emphasised }) => {
                    if (emphasised) {
                        return <strong key={str}>{str}</strong>;
                    }
                    return str;
                })}
            </span>
        );
    }

    render() {
        return (
            <div
                className="m2g-customer-address-form-predictions-container m2g-autocomplete-container"
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
            >
                <div className="m2g-customer-address-form-predictions m2g-autocomplete">
                    <div className="m2g-customer-address-form-predictions-list m2g-autocomplete-list">
                        {this.props.list.map(
                            (item, i) => (
                                <div
                                    key={i}
                                    tabIndex="0"
                                    onClick={() => this.props.onSelect(item)}
                                    onTouchStart={() =>
                                        this.props.onSelect(item)
                                    }
                                    onFocus={() => this.props.onHighlight(item)}
                                    onMouseEnter={() =>
                                        this.props.onHighlight(item)
                                    }
                                    className={classNames(
                                        'm2g-customer-address-form-predictions-item m2g-autocomplete-item',
                                        {
                                            'm2g-autocomplete-item--highlighted':
                                                item.place_id ===
                                                this.props.highlighted_item
                                                    .place_id,
                                        }
                                    )}
                                >
                                    <span
                                        className={classNames(
                                            'm2g-icon',
                                            'm2g-customer-address-form-predictions-item-icon',
                                            'm2g-autocomplete-item-icon',
                                            {
                                                'm2g-icon--location': !item.is_saved_address,
                                                'm2g-icon--star':
                                                    item.is_saved_address,
                                            }
                                        )}
                                    />

                                    <span className="m2g-autocomplete-item-text">
                                        {this.emphasisMatchedStrings(
                                            item.description,
                                            item.matched_substrings
                                        )}
                                    </span>

                                    {item.is_saved_address && (
                                        <span
                                            className={classNames(
                                                'm2g-icon',
                                                'm2g-icon--cross',
                                                'm2g-customer-address-form-predictions-item-saved-icon'
                                            )}
                                            onClick={e => {
                                                this.props.onDelete(
                                                    item.address
                                                );
                                                e.stopPropagation();
                                            }}
                                        />
                                    )}
                                </div>
                            ),
                            this
                        )}
                    </div>
                    <div className="m2g-customer-address-form-predictions-logo-container m2g-autocomplete-logo-container">
                        <img
                            className="m2g-autocomplete-logo m2g-autocomplete-logo--on-light"
                            src={`${Mobi2Go.app.base_url}/store/application/v3/dist/img/maps/powered-by-google-on-white.png`}
                            alt="Powered by google"
                        />

                        <img
                            className="m2g-autocomplete-logo m2g-autocomplete-logo--on-dark"
                            src={`${Mobi2Go.app.base_url}/store/application/v3/dist/img/maps/powered-by-google-on-non-white.png`}
                            alt="Powered by google"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressFormPredictions;
